export const state = {
  group: {
    id: null,
    companyID: null,
    name: null,
    description: null,
    status: null,
    dateUpdate: null,
    accountIDUpdate: null
  },
  groups: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/group/state.js